import { Stats } from "./stats";

export class SeasonStats {
    statsPeriod: string;
    seasonStart: Date;
    seasonEnd: Date;
    stats: Stats[];
  }
